import { render, staticRenderFns } from "./DisciplinaryView.vue?vue&type=template&id=1863c8ec"
import script from "./DisciplinaryView.vue?vue&type=script&lang=js"
export * from "./DisciplinaryView.vue?vue&type=script&lang=js"
import style0 from "./DisciplinaryView.vue?vue&type=style&index=0&id=1863c8ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports